import { headerThemeConfig } from '../constants';
import { GIFTING_PATH } from 'lib/gifting/path';

export type HeaderTheme = 'light' | 'dark';

/** Fallback for routes with no `headerThemeConfig` entry and no force-light prefix. */
export const DEFAULT_HEADER_THEME: HeaderTheme = 'dark';

/** Always light, overriding any `headerThemeConfig` entry (parity with production). */
export const FORCE_LIGHT_HEADER_ROUTE_PREFIXES = [
  '/shop',
  '/ring/buy',
  '/ring-pro/buy',
  '/diesel-ultrahuman-ring/buy',
  GIFTING_PATH,
  '/pricing',
  // Science reading surfaces are light at every depth, and their detail routes
  // are dynamic — a `headerThemeConfig` key cannot express `/science/x/<slug>`
  // because the lookup below is exact against a CONCRETE pathname, not a route
  // template. Prefixes, no trailing slash: useHeaderRoutePath (Header.tsx)
  // trims it before resolving, so '/science/studies/' would miss the hub.
  //   '/science/studies'    hub (white band) + white-paper detail (#efefef)
  //   '/science/explainers' hub + /category/<clusterKey> + /<slug>
  //   '/science/accuracy'   /<slug>
  // '/science/ask' is DELIBERATELY absent: AskDetail is #0a0a0a and must keep
  // the dark DEFAULT_HEADER_THEME. That is why a bare '/science' would be wrong.
  '/science/studies',
  '/science/explainers',
  '/science/accuracy',
];

/**
 * Precedence: `?headerTheme=` override → force-light prefix → `headerThemeConfig`
 * → default. Pure and route-derived, so nothing races on route change.
 */
export const resolveHeaderTheme = (
  pathname: string,
  themeParam?: string | null,
): HeaderTheme => {
  if (themeParam === 'dark' || themeParam === 'light') return themeParam;
  if (FORCE_LIGHT_HEADER_ROUTE_PREFIXES.some((p) => pathname.startsWith(p)))
    return 'light';
  return pathname in headerThemeConfig
    ? headerThemeConfig[pathname]
    : DEFAULT_HEADER_THEME;
};
